export default __webpack_public_path__ + "static/media/019-eyepatch.94816d53.png";